import { useNavigation } from '@refinedev/core';

import { Button } from '@rrexpress/core';

export function ErrorBoundaryActions() {
  const onBackToDashboard = () => {
    window.location.href = window.location.origin;
  };

  const onRefreshPage = () => {
    window.location.reload();
  };

  return (
    <div className="flex items-center gap-x-8">
      <Button variant="tertiary" onClick={onBackToDashboard}>Pergi ke Dashboard</Button>
      <Button variant="tertiary" onClick={onRefreshPage}>Refresh halaman</Button>
    </div>
  );
}

export default ErrorBoundaryActions;
